import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable, NgZone } from '@angular/core';
import { ToastService } from '../../shared/components/toast/toast.service';
import { LoggerService } from '../../shared/core/services/logger.service';

/** Une rafale d'erreurs (boucle de rendu, minuterie) ne produit qu'un toast par fenetre. */
const FENETRE_TOAST_MS = 5000;

/**
 * Gestionnaire global des erreurs non capturees (audit R-30).
 *
 * Le gestionnaire par defaut d'Angular ecrivait dans la console et rien d'autre : l'agent ne
 * voyait aucun signe de l'echec. Les erreurs HTTP sont exclues du toast, l'`errorInterceptor`
 * en a deja affiche un.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private readonly logger = inject(LoggerService);
    private readonly toast = inject(ToastService);
    private readonly zone = inject(NgZone);
    private dernierToast = 0;

    handleError(error: unknown): void {
        this.logger.error('Erreur non capturee', error);

        if (error instanceof HttpErrorResponse || Date.now() - this.dernierToast < FENETRE_TOAST_MS) {
            return;
        }
        this.dernierToast = Date.now();
        this.zone.run(() => this.toast.error('Erreur inattendue', "L'opération n'a pas abouti. Rechargez la page si le problème persiste."));
    }
}
